import { render, staticRenderFns } from "./Billboard2.vue?vue&type=template&id=8069c34e&scoped=true&"
import script from "./Billboard2.vue?vue&type=script&lang=js&"
export * from "./Billboard2.vue?vue&type=script&lang=js&"
import style0 from "./Billboard2.vue?vue&type=style&index=0&id=8069c34e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8069c34e",
  null
  
)

export default component.exports